export default __webpack_public_path__ + "static/media/Chevin_Medium.4b9239e0.ttf";